import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  reportData: null,
};

const researchReportSlice = createSlice({
  name: 'researchReport',
  initialState,
  reducers: {
    generateResearchReportStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    generateResearchReportSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.reportData = action.payload;
    },
    generateResearchReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearResearchReport: (state) => {
      state.loading = false;
      state.error = null;
      state.reportData = null;
    },
    getResearchReportStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getResearchReportSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.reportData = action.payload;
    },
    getResearchReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    generateOutlineStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    generateOutlineSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.outlineData = action.payload;
    },
    generateOutlineFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getOutlineStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOutlineSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.outlineData = action.payload;
    },
    getOutlineFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    generateScriptStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    generateScriptSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.scriptData = action.payload;
    },
    generateScriptFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteHookStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteHookSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      // Update outlineData to remove the deleted hook from sequences
      if (state.outlineData?.sequences) {
        state.outlineData.sequences = state.outlineData.sequences.filter(
          (sequence) => sequence._id !== action.payload
        );
      }
    },
    deleteHookFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateHookStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateHookSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      if (state.outlineData?.sequences) {
        const { hookId, hookText } = action.payload;
        const sequenceIndex = state.outlineData.sequences.findIndex(
          (sequence) => sequence._id === hookId
        );
        if (sequenceIndex !== -1) {
          state.outlineData.sequences[sequenceIndex].hook.text = hookText;
        }
      }
    },
    updateHookFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  generateResearchReportStart,
  generateResearchReportSuccess,
  generateResearchReportFailure,
  clearResearchReport,
  getResearchReportStart,
  getResearchReportSuccess,
  getResearchReportFailure,
  generateOutlineStart,
  generateOutlineSuccess,
  generateOutlineFailure,
  getOutlineStart,
  getOutlineSuccess,
  getOutlineFailure,
  generateScriptStart,
  generateScriptSuccess,
  generateScriptFailure,
  deleteHookStart,
  deleteHookSuccess,
  deleteHookFailure,
  updateHookStart,
  updateHookSuccess,
  updateHookFailure,
} = researchReportSlice.actions;

export default researchReportSlice.reducer;

